module.exports = __webpack_public_path__ + "static/media/14@960w.368dc1cf.jpg";